import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/calendarDetail/closeCircle.svg';
import { ReactComponent as IconSvg2 } from '@/images/icons/calendarDetail/closeCircleHover.svg';
const CloseCircleSvg = () => React.createElement(IconSvg, null);
CloseCircleSvg.Enhance = () => React.createElement(IconSvg2, null);
export default CloseCircleSvg;
